import {
    Text,
    Box,
    Title,
    Button,
    createStyles,
    Group,
    Anchor,
    Divider,
    Paper,
    ThemeIcon,
    SimpleGrid,
} from '@mantine/core';

type DashboardPanelProps = {
    title: string;
    description: string;
    icon: any;
    gradient1: string;
    gradient2: string;
    iconColour: string;
};


export const DashboardPanel = ({ title, description, icon, gradient1, gradient2, iconColour }: DashboardPanelProps) => {
    const useStyles = createStyles((theme) => ({
        colourCard: {
            position: 'relative',
            cursor: 'pointer',
            overflow: 'hidden',
            transition: 'transform 150ms ease, box-shadow 100ms ease',
            padding: theme.spacing.xl,
            paddingLeft: theme.spacing.xl * 2,

            '&:hover': {
                boxShadow: theme.shadows.md,
                transform: 'scale(1.02)',
            },

            '&::before': {
                content: '""',
                position: 'absolute',
                top: 0,
                bottom: 0,
                left: 0,
                width: 6,
                backgroundImage: theme.fn.linearGradient(0, gradient1, gradient2),
            },
        },
    }));

    const { classes } = useStyles();

    return (
        <Paper withBorder radius="md" className={classes.colourCard}>
            <ThemeIcon size="xl" radius="md" color={iconColour} >
                {icon}
            </ThemeIcon>
            <Text size="xl" weight={500} mt="md">
                {title}
            </Text>

            <Text size="sm" mt="sm" color="dimmed">
                {description}
            </Text>
        </Paper>
    );
};